<template>
  <div>
    <Heade>
      <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/')"></template>
      <template v-slot:title>在线参会</template>
    </Heade>
     <!--选择会议提示框-->
    <div class="selectHuiyi" v-if="isMeeting">
        <div class="MengchengBg"></div>
        <div class="Mengcheng_con">
            <div class="Mengcheng_top">
                <div><img src="../../assets/img/diandiandain111.png" alt=""></div>
                <div>请选择参加的会议</div>
            </div>
            <div id="mySelectHuiyi">
              <van-radio-group v-model="radio" >
                  <van-radio 
                  :name="item" 
                  v-for="(item,index) in MeetingList" 
                  @click='handleRadio(item.online_meeting_url)'
                  :key="index" 
                  class="f_radio" 
                  checked-color="#0b0343"> {{item.meeting_place}}<span class="sign">{{item.sigin_id ? '已签到':'未签到'}}</span></van-radio>
              </van-radio-group>
            </div>
            <div class="selectHuiyiJX" @click="meetingForward">继续</div>
        </div>
    </div>

     <!--没有会议-->
    <div class="selectHuiyi" v-if="noneMeeting">
        <div class="MengchengBg"></div>
        <div class="Mengcheng_con">
            <div class="Mengcheng_top">
                <div><img src="../../assets/img/diandiandain111.png" alt=""></div>
                <div>提示</div>
            </div>
            <div id="mySelectHuiyi">
              <div class="text">现在没有会议,请关注下场会议开始时间！</div>
            </div>
            <div class="selectHuiyiJX" @click="$router.push('/')">确定</div>
        </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      noneMeeting: false, //没有会议
      isMeeting: false, //会议选择开关
      MeetingList: [], //会议列表
      radio: "", //选中的会议
      url: "" //直播地址
    };
  },
  //接收来自父组件的数据
  props: {},
  //生命周期实例创建完成后被立即调用
  created() {},
  //生命周期挂载完成之后被调用
  mounted() {
    // const openid = sessionStorage.getItem("openid");
    const openid = this.$store.state.openId
    console.log('liveopenid',openid)
    if (openid) {
      this.isJurisdiction(openid);
    }else if (openid == "null" || openid == "" || openid == null) {
      var weiCode = this.getQueryString("code");
      // console.log("weiCode", weiCode);
      this.getOpenid(weiCode);
    }
  },
  //组件
  components: {},
  //方法
  methods: {
    // 处理地址
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getOpenid(weiCode) {
      const _this = this;
      const url = "/queryWeiXin";
      var xhr = new XMLHttpRequest();
      xhr.open("post", "https://rhgt.api.anlongmaide.com" + url, true);
      xhr.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded;charset=UTF-8"
      );
      var data = { code: weiCode };
      let ret = "";
      for (const it in data) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      }
      xhr.send(ret);
      xhr.onreadystatechange = function() {
        if (xhr.status == 200 && xhr.readyState == 4) {
          const data = JSON.parse(xhr.responseText);
          console.log("微信openid",data.weixin)
          if (data.weixin) {
            sessionStorage.setItem("openid", data.weixin);
            _this.$store.commit("setOpenId", data.weixin);
          } else {
            let urlQian =  location.href.split('?')[0]                            
            let urlHou = location.href.split('#')[location.href.split('#').length-1]
            let Url = `${urlQian}#${urlHou}`;
            let shareUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcc0a796f6b6cfa33&redirect_uri=${encodeURIComponent(Url)}&res&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
            // window.location.href = shareUrl
            // _this.$store.commit("setOpenId", '819819819681651818');
            // sessionStorage.setItem("openid", "819819819681651818");
          }
           _this.isJurisdiction(_this.$store.state.openId);
           console.log("store微信openid",_this.$store.state.openId)
        }
      };
    },
    //可签到会议列表
    isJurisdiction(openid) {
      const url = "/canSiginMeetingList";
      this.axios.post(url, { weixin: openid, meetingType: 2 }).then(res => {
        if (res.data.code === "00000") {
          //console.log(res);
          const list = res.data.model;
          if (list.length > 1) {
            this.isMeeting = true;
            this.MeetingList = list;
          } else if (list.length == 1) {
            this.isMeeting = false;
            const sigin_id = list[0].sigin_id; //已经签到的标记
            if (sigin_id) {
              setTimeout(() => {
                //window.open(list[0].online_meeting_url);
                window.location = list[0].online_meeting_url
              }, 1000);
            } else {
              this.$router.push("/Sign");
            }
          } else {
            this.noneMeeting = true;
          }
        }
      });
    },
    handleRadio(url) {
      console.log(url);
      this.url = url;
    },
    //会议选择完点击继续
    meetingForward() {
      if (this.radio) {
        // if (this.url) {
        //   window.location = this.url;
        //   this.isMeeting = false;
        // }
        
        if(this.radio.sigin_id){
          window.location = this.radio.online_meeting_url;
          this.isMeeting = false;
        }else{          
          this.$router.push({
            path: '/Sign',
            query:{
              queryRadio: this.radio
            },
          });
        }
      } else {
        Toast("请选择会议");
        // this.$router.push("/Sign");
      }
    }
  },
  //监视
  watch: {}
};
</script>
<style lang="less" scoped>
.selectHuiyi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .MengchengBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.3;
    z-index: -1;
  }
  .Mengcheng_con {
    width: 520px;
    height: 553px;
    background-color: white;
    border-radius: 20px;
    margin: auto;
    margin-top: 40%;
    .Mengcheng_top {
      width: 100%;
      height: 255px;
      border-radius: 8px 8px 0 0;
      /* background: url("../../images/qt/landi.png") no-repeat center; */
      background: #007aff;

      background: -webkit-linear-gradient(left top, #78c4ff, #007aff);

      background: -moz-linear-gradient(left top, #78c4ff, #007aff);

      background: -ms-linear-gradient(left top, #78c4ff, #007aff);

      background: -o-linear-gradient(left top, #78c4ff, #007aff);

      background: linear-gradient(to left top, #78c4ff, #007aff);
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      img {
        width: 77px;
        height: 12px;
      }
      div {
        font-size: 36px;
        color: white;
        margin-top: 20px;
      }
    }
    #mySelectHuiyi {
      height: 300px;
      overflow: auto;
      background-color: white;
      .text{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        box-sizing: border-box;
        padding:0 30px;
        letter-spacing: 5px;
      }
      /deep/.van-radio {
        box-sizing: border-box;
        padding: 20px 20px 20px 30px;
        border-bottom: solid 1px #e5e5e5;
      }
      /deep/.van-cell {
        width: 100%;
        padding: 0;
      }
      /deep/.van-field__value {
        width: 100%;
      }
      /deep/.van-radio-group {
        width: 100%;
      }
      .sign {
        margin-left: 10px;
        display: inline-block;
        width: 70px;
        height: 25px;
        background: #fd2f8b;

        background: -webkit-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -moz-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -ms-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: -o-linear-gradient(left top, #fd2f8b, #fc5d31);

        background: linear-gradient(to left top, #fd2f8b, #fc5d31);
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 25px;
      }
    }
    .selectHuiyiJX {
      width: 100%;
      height: 70px;
      font-size: 32px;
      color: white;
      background-color: #1d8eff;
      border-radius: 0 0 20px 20px;
      text-align: center;
      line-height: 70px;
    }
  }
}
</style>